import constants_default from '^/components/global/constants';

const CART_VALIDATION = {
  properties: {
    contact_email: {
      type: 'string',
      format: "email",
      minLength: 5,
      maxLength: 50
    },
    contact_name: {
      type: 'string',
      minLength: 1,
      maxLength: 30
    },
    contact_phone: {
      type: 'string',
      minLength: 10,
      maxLength: 20
    },
    customer_po: {
      type: 'string',
      maxLength: 15,
    },
    comments: {
      type: 'string',
      maxLength: 150
    },
    customer_attrs: {
      type: 'object',
      properties: {
        machine_type: {
          oneOf: [
            {
              type: 'string',
              maxLength: 100,
              minLength: 1,
            },
            {
              type: 'null',
            }
          ]
        },
        number_of_heads: {
          oneOf: [
            {
              type: 'number',
              multipleOf: 1,
            },
            {
              type: 'null',
            },
          ]
        }
      }
    },
  },
  required: [
    'contact_email',
    'contact_name',
    'contact_phone',
    'ship_to_address',
    'bill_to_address',
    'customer_attrs',
  ]
}

export default {
  ...constants_default,
  AUTO_SELECT_CHEAPEST_SHIPPING_METHOD_IGNORE_KEYS: ['PID', 'OTR'],
  IS_SHOW_AVAILABILITY_IN_BIG_CART_LIST: true,
  IS_SHOW_ITEM_IN_CART_IN_RESULTS: true,
  IS_AUTO_SELECT_CHEAPEST_SHIPPING_METHOD: true,
  IS_SHOW_DOCUMENTS_IN_PRODUCT_IMAGE_CAROUSEL: true,
  IS_CAROUSEL_DOCUMENTS_FALLBACK: true,
  IS_CAROUSEL_VIDEO_FALLBACK: true,
  IS_SHOW_PRODUCT_DETAIL_RIGHT_SIDEBAR: false,
  IS_COLLAPSE_MX_CATEGORY_DESCRIPTION: false,
  IS_SHOW_BILL_OF_MATERIALS_CONTENTS_IN_PRODUCT_DETAIL: true,
  IS_REGISTER_DEFAULT: true,
  IS_SHOW_THANK_YOU_CART_REFERENCE: false,
  CART_VALIDATION,
  DROPSHIP_WORDING: 'Item shipped by manufacturer—usually ships within 1-5 days',
  RETAILERS_ONLY_BUTTON_TEXT: 'Retailers Only',
  COMING_SOON_BUTTON_TEXT: 'Coming Soon',
  BRAND_LOGO_IMAGE: '/static/img/client/gunold-brand-logo.webp',
}



// WEBPACK FOOTER //
// ./ixcms/themes/gunoldusa/src/vue-src/components/global/constants.js